import React from "react";

const LoadTable = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-0">
      <div className="mt-2 flow-root px-4">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="max-h-svh overflow-y-auto animate-pulse">
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    {Array.from({ length: 9 }).map((_, index) => (
                      <th
                        key={index}
                        scope="col"
                        className="px-4 py-3 bg-white"
                      >
                        <div className="h-4 w-24 bg-gray-200 rounded"></div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <tr key={index}>
                      {Array.from({ length: 9 }).map((__, colIndex) => (
                        <td key={colIndex} className="px-4 py-5">
                          <div className="h-4 bg-gray-200 rounded w-full"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="flex justify-end py-4">
          <div className="h-8 w-40 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadTable;
